import { WorkAreaMapLocationNode } from 'modules/space_control/hooks/useWorkAreaMap'
import { WorkAreaMapNodes } from 'modules/space_control/hooks/useWorkAreaMaps'

export interface WorkSpacesMapProps {
  workAreaId: string
  date: string
  endTime?: string
  startTime?: string
  actions: MapActions
  mapMode?: MapMode
  map: WorkAreaMapNodes
  cardMode?: CardMode
  workAreaMapLocations: WorkAreaMapLocationNode[]
}

export interface MapActions {
  onPinClick?: (data: { workAreaMapLocation: WorkAreaMapLocationNode | null }) => void
  onMapClick?: (data: { x: number; y: number }) => void
  onPinHover?: (data: { workAreaMapLocation: WorkAreaMapLocationNode | null }) => void
}

export type MapMode = 'DEFAULT' | 'PLACE_PIN'
export type CardMode = 'BOOKING' | 'EDITING'

export const MAP_MODE: Record<MapMode, MapMode> = { DEFAULT: 'DEFAULT', PLACE_PIN: 'PLACE_PIN' }
export const CARD_MODE: Record<CardMode, CardMode> = { BOOKING: 'BOOKING', EDITING: 'EDITING' }
